/* Product page: a product video plays when the mouse is over it (desktop only), and pauses when the mouse leaves.
   Touch screens keep the normal tap-to-play. Uses the theme's own <deferred-media> loader, muted, looping. 4 Oct 2026. */
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var saver = navigator.connection && navigator.connection.saveData;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!canHover && (saver || calm || !('IntersectionObserver' in window))) return;

  function isVideo(dm) {
    var t = dm.querySelector('template');
    return !!(t && t.content && t.content.querySelector('video'));
  }

  function attach(dm) {
    if (dm.dataset.hoverPlay === '1' || !isVideo(dm)) return;
    dm.dataset.hoverPlay = '1';
    if (!canHover) {
      // Touch screens: no hover, so play by itself while the video is on screen (muted, looping), pause when it leaves.
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            if (!dm.getAttribute('loaded') && typeof dm.loadContent === 'function') dm.loadContent(false);
            var v = dm.querySelector('video');
            if (!v) return;
            v.setAttribute('playsinline', ''); v.muted = true; v.loop = true;
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else {
            var w = dm.querySelector('video'); if (w) w.pause();
          }
        });
      }, { threshold: 0.5 }).observe(dm);
      return;
    }
    dm.addEventListener('mouseenter', function () {
      if (!dm.getAttribute('loaded') && typeof dm.loadContent === 'function') dm.loadContent(false);
      var v = dm.querySelector('video');
      if (!v) return;
      v.muted = true;
      v.loop = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
    dm.addEventListener('mouseleave', function () {
      var v = dm.querySelector('video');
      if (v) v.pause();
    });
  }

  function scan() {
    document.querySelectorAll('deferred-media[data-media-id]').forEach(attach);
  }

  var queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
})();
